import React from 'react';
import {
  Box,
  makeStyles,
  Typography,
  Divider,
  Button
} from '@material-ui/core';
import PropTypes from 'prop-types';
import moment from 'moment';
import { ABYSS_VERSION_HISTORY } from '../../../../constants';
import { map } from 'lodash';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  bannerOverlay: {
    color: theme.palette.tertiary.secondary,
    paddingTop: '2rem',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch',
    alignItems: 'center',
    backgroundColor: theme.palette.secondary.secondary,
    boxShadow: '0px 0px 1px 1px #cdd2d2'
  },
  headerContainer: {
    width: '55%',
    minWidth: '1200px',
    display: 'flex',
    flexWrap: 'wrap'
  },
  leaderboardButtonSelected: {
    backgroundColor: `${theme.palette.secondary.main}40`,
    textTransform: 'none',
    marginRight: '0.2rem',
    '&:hover': {
      backgroundColor: `${theme.palette.secondary.main}40`
    }
  },
  leaderboardButton: {
    textTransform: 'none',
    marginRight: '0.2rem'
  }
}));

function AbyssLeaderboardBanner(props) {
  const classes = useStyles();

  const sortedHistory = ABYSS_VERSION_HISTORY.sort((a, b) => {
    const versionA = a.split(' ');
    const versionB = b.split(' ');

    const majorMinorA = versionA[0].split('.').map(Number);
    const majorMinorB = versionB[0].split('.').map(Number);

    for (let i = 0; i < Math.max(majorMinorA.length, majorMinorB.length); i++) {
      if ((majorMinorA[i] || 0) !== (majorMinorB[i] || 0)) {
        return (majorMinorB[i] || 0) - (majorMinorA[i] || 0);
      }
    }

    if (versionA[1] && versionB[1]) {
      return versionB[1].localeCompare(versionA[1]);
    }

    return versionA[1] ? -1 : 1;
  });

  const lastUpdatedElapsed = moment.duration(
    moment().diff(moment(props.leaderboard.last_synced_at))
  );

  const days = parseInt(lastUpdatedElapsed.asDays());
  const hours = parseInt(lastUpdatedElapsed.asHours()) % 24;
  const minutes = parseInt(lastUpdatedElapsed.asMinutes()) % 60;

  return (
    <Box className={classes.bannerOverlay}>
      <Box classes={{ root: classes.headerContainer }}>
        <Typography
          style={{ fontSize: '24px', fontWeight: '700' }}
        >{`${props.version} Abyss Standings`}</Typography>
        <Box mr={2} />
        <Typography
          style={{ fontSize: '12px', color: '#a6abbd' }}
        >{`Last Updated: ${days ? `${days} day(s),` : ''} ${
          hours ? `${hours} hour(s),` : ''
        } ${minutes ? `${minutes} minute(s)` : ''} ago`}</Typography>
      </Box>
      <Box mt={2} />
      <Divider style={{ width: '100%' }} />
      <Box mt={0.5} />
      <Box classes={{ root: classes.headerContainer }}>
        {map(sortedHistory, (version, idx) => {
          return (
            <Button
              classes={{
                root: clsx({
                  [classes.leaderboardButtonSelected]:
                    props.version === version,
                  [classes.leaderboardButton]: props.version !== version
                })
              }}
              key={idx}
              onClick={() => props.updateVersion(version)}
            >
              {version}
            </Button>
          );
        })}
      </Box>
      <Box mt={0.5} />
    </Box>
  );
}

AbyssLeaderboardBanner.propTypes = {
  leaderboard: PropTypes.object.isRequired,
  version: PropTypes.string.isRequired,
  updateVersion: PropTypes.func.isRequired
};

export default AbyssLeaderboardBanner;
